module.exports = __webpack_public_path__ + "img/answerFalse.3c80f6d7.png";